<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text class="editor-content">
        <section class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8"><v-text-field v-model="fields.title" label="Name" hide-details/></v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </section>

        <SectionSettingsContainerFuild
          class="mb-4"
          :settings="fields.settings"
          :container-page="fields.containerPage"
          :show-container-page="false"
          :use-background-mobile="false"
          :show-background-image="false"
        />

        <section class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Slider images</label>
            <v-btn small text color="primary" @click="handleAddImage"> <v-icon small>mdi-plus</v-icon>Add image </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(image, index) in fields.images" :key="`furnitureshop-slider-image-${index}`">
              <v-expansion-panel-header>
                <span>Image {{ index + 1 }}</span>
                <template #actions>
                  <v-btn icon @click.stop="handleRemoveImage(index)"><v-icon color="error">mdi-delete</v-icon></v-btn>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <UploadImage
                  :image="{ imageSrc: image }"
                  :height="'180'"
                  :typeUpload="'image'"
                  @callback="obj => handleUploadImage(obj, index)"
                  @callbackDelete="() => handleDeleteImage(index)"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </section>

        <section>
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Feature items</label>
            <v-btn small text color="primary" @click="handleAddItem"> <v-icon small>mdi-plus</v-icon>Add item </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.items" :key="`furnitureshop-slider-item-${index}`">
              <v-expansion-panel-header>
                <span>{{ index + 1 }}. {{ item.text || 'Item' }}</span>
                <template #actions>
                  <v-btn icon @click.stop="handleRemoveItem(index)"><v-icon color="error">mdi-delete</v-icon></v-btn>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="field-label">Image</p>
                <UploadImage
                  :image="{ imageSrc: item.image }"
                  :height="'140'"
                  :typeUpload="'image'"
                  @callback="obj => handleUploadItemImage(obj, index)"
                  @callbackDelete="() => handleDeleteItemImage(index)"
                />
                <v-text-field v-model="item.text" class="mt-4" label="Text" hide-details />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </section>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions>
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update.js';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'FurnitureshopGridSlider',
  components: { UploadImage, SectionSettingsContainerFuild },
  props: { sectionEditor: { type: Object, required: true } },
  data() {
    return {
      fields: {
        title: 'Furnitureshop grid slider',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#181818',
          textColor: '#FFFFFF',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
        images: [],
        items: [
          { image: '', text: 'Gloss' },
          { image: '', text: 'Durability' },
          { image: '', text: 'Protection' },
        ],
      },
    };
  },
  watch: {
    sectionEditor: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value?.show && value.sectionExtract) this.applyExtract(value.sectionExtract);
      },
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        images: Array.isArray(extract.images) ? [...extract.images] : this.fields.images,
        items: Array.isArray(extract.items) ? extract.items.map(item => ({ ...item })) : this.fields.items,
      };
    },
    handleAddImage() {
      this.fields.images.push('');
    },
    handleRemoveImage(index) {
      this.fields.images.splice(index, 1);
    },
    handleUploadImage(obj, index) {
      this.$set(this.fields.images, index, obj?.imageSrc || '');
    },
    handleDeleteImage(index) {
      this.$set(this.fields.images, index, '');
    },
    handleAddItem() {
      this.fields.items.push({ image: '', text: 'Feature' });
    },
    handleRemoveItem(index) {
      this.fields.items.splice(index, 1);
    },
    handleUploadItemImage(obj, index) {
      if (this.fields.items[index]) this.$set(this.fields.items[index], 'image', obj?.imageSrc || '');
    },
    handleDeleteItemImage(index) {
      if (this.fields.items[index]) this.$set(this.fields.items[index], 'image', '');
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionFurnitureshopGridSlider(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', { ...this.sectionEditor.section, title: this.fields.title, html });
      this.handleClosePopup();
    },
  },
};
</script>
